export default {"src":"/pro/_next/static/media/ltc.3ad1557c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};